export default {
  PERSONALITY_SURVEYS_FETCHED: 'PERSONALITY_SURVEYS_FETCHED',
  PERSONALITY_SURVEY_LOAD: 'PERSONALITY_SURVEY_LOAD',
  PERSONALITY_SURVEY_DETAIL: 'PERSONALITY_SURVEY_DETAIL',
  RESEARCH_TEMPLATES_FETCHED: 'RESEARCH_TEMPLATES_FETCHED',
  RESEARCH_TEMPLATES_LOAD: 'RESEARCH_TEMPLATES_LOAD',
  PERSONALITY_SURVEY_BUTTON_LOAD: 'PERSONALITY_SURVEY_BUTTON_LOAD',
};
